import React, { useMemo, useCallback } from 'react';
import buildAccordionClickFunction from 'helper/buildAccordionClickFunction';

import Accordion from 'components/Accordion';
import RadioButton from 'components/DesignSystem/RadioButton';
import useTimeFrequency from 'hooks/Meteorology/Agro/TrackingForecast/DetailedView/useTimeFrequency';

export default function TimeFrequencies() {
  const {
    timeFrequencies,
    selectedTimeFrequency,
    setTimeFrequency,
  } = useTimeFrequency();
  const closeAccordion = useMemo(() => buildAccordionClickFunction('time-frequencies-accordion'), []);
  const setTimeFrequencyAndClose = useCallback((newTimeFrequency : string) => {
    setTimeFrequency(newTimeFrequency);
    closeAccordion();
  }, [setTimeFrequency, closeAccordion]);

  return (
    <Accordion.Item eventKey="time-frequencies" id="time-frequencies-accordion">
      <Accordion.Header>Frequência Temporal</Accordion.Header>
      <Accordion.Body>
        {timeFrequencies.map((timeFrequency) => (
          <RadioButton
            key={timeFrequency.value}
            label={timeFrequency.label}
            checked={timeFrequency.value === selectedTimeFrequency?.value}
            onChange={() => setTimeFrequencyAndClose(timeFrequency.value)}
            className="my-2"
          />
        ))}
      </Accordion.Body>
    </Accordion.Item>
  );
}
